var foreach = require('foreach');
module.exports = function merge(destination /* , sources */) {
  var sources = Array.prototype.slice.call(arguments);
  foreach(sources, function (source) {
    for (var keyName in source) {
      if (source.hasOwnProperty(keyName)) {
        if (typeof destination[keyName] === 'object' && typeof source[keyName] === 'object') {
          destination[keyName] = merge({}, destination[keyName], source[keyName]);
        } else if (source[keyName] !== undefined) {
          destination[keyName] = source[keyName];
        }
      }
    }
  });
  return destination;
};